import { Link } from "react-router-dom";
const ServicesPage = () => {
  return (
    <div>
      <section className="pt-40 desktop:pb-0 pb-12 bg-[#212121] bg-[url('https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')] bg-p  desktop:bg-[center_top_5rem] bg-contain bg-no-repeat img-blog overflow-hidden relative">
        <div className="max-w-[1200px] flex mx-auto relative  ">
          <div className="flex flex-col desktop:flex-1 desktop:w-full desktop:items-center px-6 mb-12 w-[52.5%]">
            <div className="text-sm font-bold font1  mb-12 text-[#777]">
              <a className=" " href="/">
                <span className="text-blueLink">Home</span>
              </a>
              <span class="fa mx-2 text-[9px]"></span>
              Services
            </div>
            <div className="px-[40px] py-[64px] bg-white desktop:bg-transparent  ">
              <a
                href="single-post.html"
                className=" text-[#212121] inline-block"
              >
                <h1 className="font2 text-[#333] desktop:text-[#fff] desktop:font-light text-[52px] leading-[1.15] font-semibold mb-2">
                    We design tailor made strategy for your business goal
                </h1>
                <div className="mb-6 text-xl desktop:text-[#fff] font1 desktop:font-light leading-normal">
                    We value our craft, have a deep passion for progression, and exist to solve challenges for brands we believe in
                </div>
              </a>
            </div>
          </div>
          <div className="flex-col flex-auto w-[47.5%] lg-5 px-12 mb-0" />
        </div>
        <div className="gradient-overlay hidden-only-lg" />
      </section>

      <section className="pt-24 pb-12 bg-[#fff]"> {/*bikin grid 5x2*/}
        <div className=" max-w-[1200px] flex desktop:flex-col-reverse items-center  mx-auto relative">
                
          <div className="desktop:flex-col desktop:w-auto text-center">
            <div className="pre-title-container">
              <div className="relative inline-block mb-1 pl-1 pr-2 w-[18%] bg-[#F8F8F8] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
              <div className="relative inline-block mb-1 pl-1 pr-2 bg-[#FFF] font1 text-blueLink text-[12px] font-medium tracking-wider uppercase">
                here's how we work
              </div>
              </div>
              <div className="pre-title-decoration" />
            </div>
            <h3 className="mt-0 mb-[10px] text-[36px] leading-[1.4] font-black font2">
              {" "}
              Our Process
            </h3>
            <div className="grid grid-cols-5 gap-x-10 text-left font1">
              <div className="bg-[url('https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d6600aaf0c4157a443cbacf_step1.svg')] bg-contain bg-no-repeat img-blog overflow-hidden relative h-52 text-white">.</div>
              <div className="bg-[url('https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d6600ab45315233079924b0_step2.svg')] bg-contain bg-no-repeat img-blog overflow-hidden relative"></div>
              <div className="bg-[url('https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d6600abf0c415bb423cbad0_step3.svg')] bg-contain bg-no-repeat img-blog overflow-hidden relative"></div>
              <div className="bg-[url('https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d6600aa5e626fcc812611a0_step4.svg')] bg-contain bg-no-repeat img-blog overflow-hidden relative"></div>
              <div className="bg-[url('https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d6600aa071de802a6ecd761_step5.svg')] bg-contain bg-no-repeat img-blog overflow-hidden relative"></div>
              <div className="font-black">1. Intial research</div>
              <div className="font-black">2. Ideation phase</div>
              <div className="font-black">3. Campaign launch</div>
              <div className="font-black">4. Learn & measure</div>
              <div className="font-black">5. Optimization</div>
              <div className="font-light">
                We learn all about what your company is about 
                including your long term goals and challenges.
              </div>
              <div className="font-light">
                We'll analyze which channels and approach you're 
                currently using to market your company.
              </div>
              <div className="font-light">
                Next, we lay the foundation of your inbound marketing 
                efforts by setting up the appropriate systems to 
                maximize your budget.
              </div>
              <div className="font-light">
                Using the channels that work for your company, 
                we'll develop campaigns that attract, convert, close, 
                and delight your customers
              </div>
              <div className="font-light">
                Each month we'll review what's working and what 
                needs to be optimized.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-24 pb-12 bg-[#fff]">
        <div className="max-w-[1200px] flex mx-auto">
          <div className="col margin-bottom" />
        </div>
        <div className="max-w-[1200px] mx-auto flex desktop:flex-col">
          <div className="desktop:flex-wrap desktop:space-y-4 desktop:w-auto px-6 mb-12 w-1/2  md-12 desktop:order-[3] order-[-1] flex flex-col  justify-between">
            <div>
              <div className="pre-title-container">
                <div className="relative inline-block mb-4 pr-2 w-full h-5 bg-[#F8F8F8] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                <div className="relative inline-block mb-4 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-[12px] font-medium tracking-wider uppercase">
                  Integrated Solutions
                </div>
                </div>
              <div className="pre-title-decoration" />
              </div>
              <h3 className="mt-0 mb-[10px] text-[36px] leading-snug font-black font2">
                IT consulting
              </h3>
              <div>
                <p className="text-base leading-6 mb-8 text-[#333] font1">
                  Sed posuere consectetur est at lobortis. Duis mollis, 
                  est non commodo luctus, nisi erat porttitor ligula, eget 
                  lacinia odio sem nec elit.
                </p>
                <div className="grid grid-cols-2 text-[#333] font1 gap-x-20">
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium">Cross Channel Attribution Modeling</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium">Data Management & Personalization</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium pt-5">Business Intelligence</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium pt-5">Predictive Analysis</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="desktop:flex-wrap desktop:space-y-4 desktop:w-auto px-6 mb-12 w-1/2  md-12 desktop:order-[3] order-[-1] flex flex-col  justify-between">
            <div className="bg-gray3 text-white p-10 py-20 h-full">
              <h3 className="mt-0 mb-[10px] text-[23px] leading-snug font2">
                Capabilities
              </h3>
              <div>
                <div className="gap-20 columns-2">
                  <div>Cross-Channel Reporting & Insight Creation</div>
                  <div>Business Intelligence through Proprietary Dashboards</div>
                  <div>Proprietary Tech Platforms</div>
                  <div>KPI Development & Measurement Planning</div>
                  <div>Marketing Platform Selection & Solutions Integration</div>
                  <div>Predictive Modeling</div>
                  <div>Cross-Channel Attribution</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-24 pb-12 bg-[#fff]">
        <div className="max-w-[1200px] flex mx-auto">
          <div className="col margin-bottom" />
        </div>
        <div className="max-w-[1200px] mx-auto flex desktop:flex-col">
          <div className="desktop:flex-wrap desktop:space-y-4 desktop:w-auto px-6 mb-12 w-1/2  md-12 desktop:order-[3] order-[-1] flex flex-col  justify-between">
            <div className="bg-gray3 text-white p-10 py-20 h-full">
              <h3 className="mt-0 mb-[10px] text-[23px] leading-snug font2">
                Capabilities
              </h3>
              <div>
                <div className="gap-20 columns-2">
                  <div>Cross-Channel Reporting & Insight Creation</div>
                  <div>Business Intelligence through Proprietary Dashboards</div>
                  <div>Proprietary Tech Platforms</div>
                  <div>KPI Development & Measurement Planning</div>
                  <div>Marketing Platform Selection & Solutions Integration</div>
                  <div>Predictive Modeling</div>
                  <div>Cross-Channel Attribution</div>
                </div>
              </div>
            </div>
          </div>

          <div className="desktop:flex-wrap desktop:space-y-4 desktop:w-auto px-6 mb-12 w-1/2  md-12 desktop:order-[3] order-[-1] flex flex-col  justify-between">
            <div>
              <div className="pre-title-container">
                <div className="relative inline-block mb-4 pr-2 w-full h-5 bg-[#F8F8F8] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                <div className="relative inline-block mb-4 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-[12px] font-medium tracking-wider uppercase">
                  DEDICATED DEVELOPMENT TEAM
                </div>
                </div>
                <div className="pre-title-decoration" />
              </div>
              <h3 className="mt-0 mb-[10px] text-[36px] leading-snug font-black font2">
                Analytics & Technology
              </h3>
              <div>
                <p className="text-base leading-6 text-[#333] font1">
                  Scale your delivery capacity with dedicated developers and teams. 
                  Over the past decade, our customers succeeded by leveraging Intellectsoft’s 
                  process of building, motivating, and managing software development teams.
                </p>
                <div className="grid grid-cols-2 text-[#333] font1 gap-x-20">
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium pt-5">Short distance</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium pt-5">Skills & expertis</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium pt-5">Scaling velocity</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                  <div className="grid grid-rows-2">
                    <h5 className="text-[20px] font-medium pt-5">High loyalty</h5>
                    <p className="text-[16px] font-light">Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section  className="w-full flex flex-col justify-center bg-white pb-20">
        <div className="flex">
        <div className="w-[30%] h-40 bg-gray-100"></div>
          <div className="w-[70%] flex flex-col justify-end pt-10 pb-5 pl-10">
              <div className="pre-title-container">
                <div className="relative inline-block mb-4 pr-2 w-[70%] h-5 bg-[#F8F8F8] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                <div className="relative inline-block mb-4 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-[12px] font-medium tracking-wider uppercase">
                  Let's work together
                </div>
                </div>
                <div className="pre-title-decoration" />
              </div>
              <span className="text-bold text-3xl font-medium text-gray2 font2">
              We can help your business grow
              </span>
              <p className="font1 text-gray2 text-xs mt-2">
                Let's have a friendly chat to find out
              </p>
            </div>
          </div>
      </section>
    </div>
  );
};

export default ServicesPage;
